import { Tenant } from '../../api/api-tenant';
import { baseApi } from '../../app/baseApi';

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTenants: builder.query<Tenant[], void>({
      query: () => {
        return {
          url: '/fleet/tenants',
          method: 'GET',
        };
      },
      providesTags: ['Tenants'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTenantsQuery } = dashboardApi;
